import { useMemo } from 'react'

import { SpecialTourByCategory } from 'shared/api/tours/search'

export const useSpecialTours = (
  activeTag: string | null,
  specialToursData?: SpecialTourByCategory[],
) => {
  return useMemo(() => {
    const categories = specialToursData?.map((item) => ({
      id: item.id,
      name: item.name,
    }))

    const tours = activeTag
      ? specialToursData?.find((item) => item.id === activeTag)?.tours
      : specialToursData?.flatMap((item) => item.tours)

    return { categories, tours }
  }, [activeTag, specialToursData])
}
